import { strings } from '../../utils';
import { constants } from '../../utils/constants'
import variables from '../../scss/_variables.scss';

const IS_MOBILE = constants.USER_AGENT.isMobile ||
    constants.USER_AGENT.isTablet ||
    window.innerWidth <= constants.BREAKPOINT_TABLET;

// Figure out scrollbar width
let el = document.createElement('div');
el.style.overflowY = 'scroll';
el.style.width = '40px';
el.style.height = '40px';
document.body.appendChild(el);
let scrollBarWidth = el.offsetWidth - el.clientWidth;
document.body.removeChild(el);

export default {
    namespaced: true,
    state: {
        showNav: false,
        userScaleFactor: 1,
        padding: IS_MOBILE ? 5 : 40,
        widthLeftBar: 0,
        widthRightBar: 0,
        heightNavBar: 50,
        heightConfigBar: 60,
        variables,
        scrollBarWidth,
    },
    getters: {
        padding(state) {
            return state.padding;
        },
        dimensions(state, getters) {
            return {
                widthLeftBar: state.widthLeftBar,
                widthRightBar: state.widthRightBar,
                canvasWidth: getters._canvasW,
                canvasHeight: getters._canvasH,
                padding: state.padding,
                heightConfigBar: state.heightConfigBar,
                heightNavBar: state.heightNavBar
            }
        },
        scrollBarWidth(state) {
            return state.scrollBarWidth;
        },
        showNav(state) {
            return state.showNav;
        },
        pxDimensions(state, getters) {
            let dimensions = {};
            for (let key in getters['dimensions']) {
                dimensions[key] = strings.pixelate(getters['dimensions'][key]);
            }

            return dimensions;
        },
        scaleFactor(state, getters) {
            return state.userScaleFactor * getters._baseScaleFactor;
        },
        userScaleFactor(state) {
            return state.userScaleFactor;
        },
        percentUserScaleFactor(state, getters) {
            return parseInt(getters.userScaleFactor * 100) + '%';
        },
        bestUserScaleFactor(state, getters, rootState, rootGetters) {
            let scaleW = (getters._canvasW - getters.padding * 2) / rootGetters['form/largestPageW'];
            let userScale = scaleW / getters._baseScaleFactor;
            let base = IS_MOBILE ? 1000 : 10;
            let userScaleRounded = Math.floor(userScale * base) / base;
            return Math.min(userScaleRounded, 1.2);
        },
        variables(state) {
            return state.variables
        },
        _canvasW(state, getters, rootState, rootGetters) {
            return (
                rootGetters['page/width'] -
                state.widthLeftBar -
                state.widthRightBar
            );
        },
        _canvasH(state, getters, rootState, rootGetters) {
            return (
                rootGetters['page/height'] -
                state.heightNavBar -
                state.heightConfigBar
            );
        },
        _baseScaleFactor() {
            return constants.BROWSER_PPI / constants.FORM_PPI; // display 96 PPI
        }
    },
    mutations: {
        widthLeftBar(state, width) {
            state.widthLeftBar = width;
        },
        widthRightBar(state, width) {
            state.widthRightBar = width;
        },
        userScaleFactor(state, scaleFactor) {
            state.userScaleFactor = scaleFactor;
        },
        showNav(state, showNav) {
            state.showNav = showNav;
        }
    },
    actions: {
        setBestUserScaleFactor({ dispatch, getters }) {
            return dispatch('_setUserScaleFactor', getters.bestUserScaleFactor);
        },
        modifyUserScaleFactor({ dispatch, getters }, increment) {
            if (getters.userScaleFactor <= 0.1 && increment < 0) return;
            if (getters.userScaleFactor >= 5 && increment > 0) return;
            let scaleFactor = Math.round((getters.userScaleFactor + increment) * 100) / 100;
            return dispatch('_setUserScaleFactor', scaleFactor);
        },
        setUserScaleFactor({ dispatch }, scaleFactor) {
            return dispatch('_setUserScaleFactor', scaleFactor);
        },
        loadUserScaleFactor({ dispatch }) {
            if (localStorage.formScaleFactor !== undefined) {
                return dispatch('_setUserScaleFactor', localStorage.formScaleFactor);
            } else {
                return dispatch('setBestUserScaleFactor');
            }
        },
        async _setUserScaleFactor({ commit, rootGetters }, scaleFactor) {
            scaleFactor = parseFloat(scaleFactor) || 1.2;
            commit('userScaleFactor', scaleFactor);
            if (rootGetters['user/exists']) {
                localStorage.formScaleFactor = scaleFactor;
            }
        }
    }
} 